<div class="main-container">
  <app-page-header pageTitle="My Profile"></app-page-header>

  <div class="card-container">
    <mat-card class="profileCard" aria-labelledby="short-card-title" appearance="outlined">
      <mat-card-content class="trainerInfo">
        <h2 class="trainer-info">Trainer Information</h2>

        <form [formGroup]="profileInfo">
          <div class="form-row">
            <mat-form-field>
              <mat-label>First Name</mat-label>
              <input type="text" matInput formControlName="firstname" />
              <mat-error *ngIf="profileInfo.get('firstname')?.hasError('required')">
                First Name is required
              </mat-error>
              <mat-error *ngIf="profileInfo.get('firstname')?.hasError('pattern')">
                First name can contain only letters
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Last Name</mat-label>
              <input type="text" matInput formControlName="lastname" />
              <mat-error *ngIf="profileInfo.get('lastname')?.hasError('required')">
                Last Name is required
              </mat-error>
              <mat-error *ngIf="profileInfo.get('lastname')?.hasError('pattern')">
                Last name can contain only letters
              </mat-error>
            </mat-form-field>
          </div>

          <mat-form-field>
            <mat-label>MCT email</mat-label>
            <input type="text" matInput formControlName="email" required />
            <mat-error>MCT email is required.</mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Contact Email</mat-label>
            <input type="text" matInput formControlName="alternateEmail" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Preferred Language</mat-label>
            <mat-select formControlName="language">
              <mat-option *ngFor="let option of languageList" [value]="option.name">
                {{ option.name }}
              </mat-option>
            </mat-select>
            <mat-error>Preferred language is required.</mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Country</mat-label>
            <mat-select formControlName="country" (selectionChange)="onCountryChange($event)">
              <mat-option *ngFor="let option of countryList" [value]="option.countryName">
                {{ option.countryName }}
              </mat-option>
            </mat-select>
            <mat-error>Country is required.</mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Employment Type</mat-label>
            <mat-select formControlName="employmentType">
              <mat-option *ngFor="let option of employmentTypeList" [value]="option.value">
                {{ option.name }}
              </mat-option>
            </mat-select>
            <mat-error>Employment type is required.</mat-error>
          </mat-form-field>

          <div align="end">
            <button role="button" [disabled]="isFormSubmitted" class="save-btn" (click)="submit()" mat-flat-button>
              Save
            </button>
          </div>
        </form>
      </mat-card-content>
      <mat-divider id="horizontalDivider"></mat-divider>
      <div>
        <mat-card-title>
          <h2 class="profileSectionTitle">Change your MCT Account Email</h2>
        </mat-card-title>
        <mat-card-content>
          <p>Please click the link below to change the email address associated with your MCT account:</p>
          <a (click)="onChangeEmailClick()">Change my MCT Email</a>
        </mat-card-content>
      </div>
    </mat-card>

    <div class="profileCardColumn">
      
      <mat-card class="profileCard" aria-labelledby="short-card-title" appearance="outlined" *ngIf="this.currentDate >= this.renewalDate">
        <mat-card-title>
          <h2 class="profileSectionTitle">Renewal status</h2>
        </mat-card-title>

        <div>
          <ng-container *ngIf="mtmDetails?.numberOfClasses >= 6 else mtmNotEligible">
            <p class="mtm-message">Congratulations, you have met the 6-session renewal requirement. Please remember to
              complete your renewal application and complete your payment prior to your MCT status expiration date.</p>
          </ng-container>
          <ng-template #mtmNotEligible>
            <p class="mtm-message">
              Sorry - You have not met the 6-session renewal requirement. 
              <br /> <br />
              As of now, we have a total of {{ mtmDetails?.numberOfClasses ?? 0 }} sessions on file under your MCT ID. 
              <br /><br />
              Fortunately, you are eligible for our alternative renewal pathway. Don't let your status lapse! To learn more, please
              visit: <a href="https://aka.ms/MCT_Renewal_Assessment" target="_blank">aka.ms/MCT_Renewal_Assessment</a>
              <br /> <br />
              <strong>Please Note:</strong> MTM data is synced to the portal every Friday. If you have recently logged a class on MTM,
              It may take up to one week for your renewal eligibility to be reflected in the portal.</p>
          </ng-template>
        </div>


        <!-- <div class="data-row">
          <div class="data-field mtm-data-field">
            <span class="title"> Number of classes taken during your last renewal :</span>
            <span class="value">{{ mtmDetails?.numberOfClasses ?? '-' }}</span>
          </div>
        </div>

        <div class="data-row">
          <div class="data-field mtm-data-field">
            <span class="title">Renewal eligibility :</span>
            <span class="value">{{ mtmDetails?.isMtmEligible ? 'Yes' : 'No' }}</span>
          </div>
        </div> -->
      </mat-card>


      <mat-card class="profileCard" aria-labelledby="short-card-title" appearance="outlined">

        <div>
          <mat-card-title>
            <h2 class="profileSectionTitle">Subscription Details</h2>
          </mat-card-title>
          <div class="data-row">
            <div class="data-field">
              <span class="title">START DATE:</span>
              <span class="value">{{ startDate? (startDate | date:'MMMM dd, yyyy': 'UTC') : '-' }}</span>
            </div>

            <div class="data-field">
              <span class="title">END DATE:</span>
              <span class="value">{{ endDate? (endDate | date:'MMMM dd, yyyy': 'UTC') : '-' }}</span>
            </div>

            <div class="data-field" *ngIf="status!='ALUMNI'">
              <span class="title">ACTIVE MCT SINCE:</span>
              <span class="value">{{ regDate? (regDate | date:'MMMM dd, yyyy': 'UTC') : '-' }}</span>
            </div>
          </div>
        </div>

        <div class="certificate-container">
          <mat-card-title>
            <h2 class="profileSectionTitle">My Certificate</h2>
          </mat-card-title>
          <mat-card-content>
            <p style="font-size:14px">Access and download your verified certificate</p>
            <a (click)="downloadCertificate()" *ngIf="!downloadingCertificate"
              [ngClass]="{'disabled-link': (enDate === 'null' && (status === 'TEST_OUT_PASS' || status === 'TEST_OUT_FAIL' || status === 'TEST_OUT_PAYMENT' || status === 'TEST_OUT_OPEN' || status === 'RENEWAL_EXAM' || status==='ILT_PAYMENT')) &&  status !== 'ACTIVE_MCT' && status !== 'RENEWAL' && status !== 'RENEWAL_REJECT' && status !== 'RENEWAL_APPROVE'}">Download
              certificate</a>
            <mat-spinner diameter="20" *ngIf="downloadingCertificate"></mat-spinner>
          </mat-card-content>

          <div class="copy-container" style="margin-top:16px;margin-bottom:10px">
            <ng-container
              *ngIf="status !== 'ALUMNI'">
              <a [ngClass]="{'disabled-link': (enDate === 'null' && (status === 'TEST_OUT_PASS' || status === 'TEST_OUT_FAIL' || status === 'TEST_OUT_PAYMENT' || status === 'TEST_OUT_OPEN' || status === 'RENEWAL_EXAM' || status==='ILT_PAYMENT')) &&  status !== 'ACTIVE_MCT' && status !== 'RENEWAL' && status !== 'RENEWAL_REJECT' && status !== 'RENEWAL_APPROVE'}"
                *ngIf="url === 'Generate link'; else copyBlock" (click)="generate()" style="cursor:pointer;">
                Generate link
              </a>

              <ng-template #copyBlock>
                <a [cdkCopyToClipboard]="url" (cdkCopyToClipboardCopied)="handleCopy()" (click)="generate()"
                  style="cursor:pointer;">
                  Copy certificate link
                </a>
              </ng-template>
            </ng-container>
          </div>
        </div>
        <hr style="border:1px solid #DFE1E1;margin-bottom:12px;margin-top:12px;width:445px" />
        <div *ngIf="userHistoryData && userHistoryData.length > 0">
          <mat-card-title>
            <h2 class="mctHistoryTitle">MCT History</h2>
          </mat-card-title>
          <mat-card-content>
            <div class="mct-history-table" >
              <table>
                <thead>
                  <tr>
                    <th>START DATE</th>
                    <th>END DATE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let history of userHistoryData">
                    <td>{{history.mctSubscriptionStartDate ? (history.mctSubscriptionStartDate | date:'MMMM dd,
                      yyyy':'UTC') : '-'}}</td>
                    <td>{{history.mctSubscriptionEndDate ? (history.mctSubscriptionEndDate | date:'MMMM dd, yyyy':'UTC')
                      :
                      '-'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </mat-card-content>
        </div>
      </mat-card>
      
    </div>
  </div>
</div>